import gql from 'graphql-tag';

export const UpdateDispatchSummaryMarket = gql`
  mutation UpdateDispatchSummaryMarketBulk($input: UpdateDispatchSummaryMarketBulkInput!) {
    updateDispatchSummaryMarketBulk(input: $input) {
      response {
        updated
        error {
          code
          message
          debug
        }
      }
    }
  }
`;
